import { DeleteOutlined } from '@ant-design/icons';
import { Col } from 'antd';

import { companySectorList } from '../../../utils/lists';
import {
  Button,
  FormItem,
  FormItemInput,
  FormItemSelect,
  TableFormList,
} from '../../index';
import { FormListItemRowStyle } from '../tableFormList/styles';

function CompanyContactRow(props: {
  index: number;
  onRemove?: (index: number | number[]) => void;
}) {
  const { index, onRemove } = props;
  return (
    <FormListItemRowStyle gutter={8}>
      <Col span={9}>
        <FormItemInput
          name={[index, 'name']}
          placeholder="Nome do Responsável"
          maxLength={100}
          required
          style={{ marginBottom: '0px' }}
        />
      </Col>
      <Col span={6}>
        <FormItemSelect
          name={[index, 'sector']}
          placeholder="Função / Setor"
          dataList={companySectorList}
          required
          style={{ marginBottom: '0px' }}
        />
      </Col>
      <Col span={7}>
        <FormItemInput
          name={[index, 'email']}
          type="email"
          placeholder="email@empresa.com.br"
          maxLength={100}
          required
          style={{ marginBottom: '0px' }}
        />
      </Col>
      <Col span={2}>
        <Button
          type="default"
          danger
          icon={<DeleteOutlined />}
          onClick={onRemove ? () => onRemove(index) : () => {}}
        />
      </Col>
      <FormItem noStyle name={[index, 'id']} />
    </FormListItemRowStyle>
  );
}

export function CompanyContactsTable() {
  return (
    <TableFormList
      FormListItemRow={CompanyContactRow}
      formListName={['contacts']}
      columns={[
        { title: 'NOME', colSpan: 9 },
        { title: 'FUNÇÃO / SETOR', colSpan: 6 },
        { title: 'E-MAIL', colSpan: 7 },
        { title: '', colSpan: 2 },
      ]}
      itemToAdd={{}}
      addButtonText="Adicionar Responsável"
      addButtonType="primary"
      addButtonStyle={{ margin: '0px 0px 8px' }}
      style={{ marginTop: '0px', marginBottom: '0px' }}
    />
  );
}
